export default __webpack_public_path__ + "static/media/633.8044e4ef.png";